import { SectionHeader } from '../SectionHeader';
import { Reveal } from '../Reveal';
import { BrowserFrame, CheckList, DemoCaption } from '../compass/shared';

// Section 8 — sales reporting: six views on one filter bar, with
// drill-through to the underlying records.
export const ReachReports = ({ sp }) => (
  <section aria-labelledby="reach-reports-heading" data-testid="reach-reports" className="bg-white py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="grid items-center gap-10 lg:grid-cols-[1fr_1.4fr]">
        <Reveal>
          <SectionHeader
            align="left"
            index="08"
            eyebrow="Sales Reports"
            title="Know what's working — and what isn't"
            description={sp.reportsCopy}
            testid="reach-reports-header"
          />
          <div className="mt-8">
            <CheckList items={sp.reportsPoints || []} testid="reach-reports-points" />
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <BrowserFrame shot={sp.shots.reports} label="Amden Reach — sales reports" data-testid="reach-reports-visual" />
          <DemoCaption />
        </Reveal>
      </div>
    </div>
  </section>
);
